export default __webpack_public_path__ + "static/media/analog-sharp-kick.299261fe.mp3";